import { Reducer, combineReducers } from 'redux';
import { Perpetrator, UpdateReport } from 'src/api';
import { MCCAction, MCCEventType, MCCTypes } from '../../types';

export const initialEventState = {
  date: { value: '', created: '', updated: '' },
  time: { value: '', created: '', updated: '' },
  location: { value: '', created: '', updated: '' },
  description: { value: '', created: '', updated: '' },
  emotion: { value: '', created: '', updated: '' },
  witness: { value: '', created: '', updated: '' },
  files: [],
  perpetrators: [],
  id: '',
};

const initialState: MCCState = {
  reportID: '',
  caseID: undefined,
  loading: false,
  saving: false,
  notfound: true,
  isSavedToDb: false,
  isExistingReport: false,
  currentReport: null,
  currentEvent: null,
  contactEmail: '',
  lastSavedResponseId: undefined,
};

export interface MCCState {
  reportID: string;
  caseID?: string;
  notfound: boolean;
  loading: boolean;
  saving: boolean;
  isSavedToDb: boolean;
  isExistingReport: boolean;
  currentReport: UpdateReport | null;
  currentEvent: MCCEventType | null;
  contactEmail?: string;
  error?: string;
  lastSavedResponseId?: string;
}

export interface Evidence {
  created: string;
  event: string | number;
  id: string | number;
  report: string;
  timestamp: string;
  type: string;
  updated: string;
  value: { id: string; path: string } | string | undefined | Perpetrator;
}

export const mccReducer: Reducer<MCCState, MCCAction> = (
  state: MCCState = initialState,
  action: MCCAction,
) => {
  switch (action.type) {
    case MCCTypes.RESET:
      return initialState;
    case MCCTypes.ADD_REPORT:
      return { ...initialState, loading: true };
    case MCCTypes.INIT_LOCAL_DRAFT:
      return {
        ...initialState,
        loading: false,
        notfound: false,
        isSavedToDb: false,
        isExistingReport: action.payload.isExistingReport,
        currentReport: {},
      };
    case MCCTypes.REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        reportID: action.payload.reportID,
        caseID: action.payload.caseID,
        isSavedToDb: true,
      };
    case MCCTypes.REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case MCCTypes.FETCH_ONE:
      return {
        ...state,
        loading: false,
        isSavedToDb: true,
        currentReport: action.payload.currentReport,
        lastSavedResponseId: undefined,
      };
    case MCCTypes.UPDATE_LOCAL_DRAFT:
      return {
        ...state,
        currentReport: action.payload.currentReport,
      };
    case MCCTypes.UPDATE_SUCCESS:
      return {
        ...state,
        reportID: action.payload.reportID,
        currentReport: action.payload.currentReport,
      };
    case MCCTypes.SAVE_DRAFT:
      return { ...state, saving: true };
    case MCCTypes.SAVE_DRAFT_SUCCESS:
      return {
        ...state,
        saving: false,
        isSavedToDb: true,
        reportID: action.payload.reportID,
        caseID: action.payload.caseID,
        lastSavedResponseId: action.payload.responseId,
      };
    case MCCTypes.SAVE_DRAFT_FAILURE:
      return { ...state, saving: false, error: action.payload.error };
    case MCCTypes.EDIT_EVENT:
      return { ...state, currentEvent: action.payload.currentEvent };
    case MCCTypes.SAVE_EMAIL:
      return { ...state, contactEmail: action.payload.contactEmail };
    case MCCTypes.SAVE_EMAIL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    case MCCTypes.ADD_REPORTED_CATEGORY:
      return {
        ...state,
        currentReport: {
          ...state.currentReport,
          reportedCategory: action.payload.reportedCategory,
        },
      };
    case MCCTypes.ADD_DETERMINED__CATEGORY:
      return {
        ...state,
        currentReport: {
          ...state.currentReport,
          determinedCategory: action.payload.determinedCategory,
        },
      };
    case MCCTypes.ADD_MI_REPORT_SOURCE:
      return {
        ...state,
        currentReport: {
          ...state.currentReport,
          miReportSource: action.payload.miReportSource,
        },
      };
    default:
      return state;
  }
};

const combinedReducer = combineReducers({
  mccReducer,
});

export default combinedReducer;
